import React from 'react';
import { Sparkles } from 'lucide-react';
import SimpleModal from '../../../components/common/SimpleModal';

interface KnowledgeOnboardingGuideModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRegister: () => void;
}

export interface OnboardingGuideVisibilityInput {
  /** URL クエリ `onboarding=1` が付いているか。 */
  onboardingParam: boolean;
  /** 一度閉じられたか（再表示させない）。 */
  dismissed: boolean;
  /** 商品一覧のロード中か。 */
  loading: boolean;
  /** ロード済みの商品件数。未ロードは null。 */
  productCount: number | null;
}

/**
 * /home のオンボーディングから `?onboarding=1` で来て、まだ商品が1件もない時にだけ
 * 案内モーダルを出す。ロード完了前（productCount=null / loading）は出さない。
 */
export const shouldShowOnboardingGuide = ({
  onboardingParam,
  dismissed,
  loading,
  productCount,
}: OnboardingGuideVisibilityInput): boolean =>
  onboardingParam && !dismissed && !loading && productCount === 0;

const KnowledgeOnboardingGuideModal: React.FC<KnowledgeOnboardingGuideModalProps> = ({
  isOpen,
  onClose,
  onRegister,
}) => (
  <SimpleModal isOpen={isOpen} onClose={onClose} title="商品情報の使い方" size="sm">
    <div className="flex flex-col gap-5">
      <div className="flex items-start gap-3">
        <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
          <Sparkles className="h-5 w-5" />
        </span>
        <p className="m-0 pt-1 text-sm leading-relaxed text-gray-600">
          商品情報は、広告の内容・画像・ブランドらしさの元になる情報です。紹介ページのURLから登録でき、URLがない場合は手入力できます。登録後も商品を選び、「基本情報」から修正できます。
        </p>
      </div>
      <ol className="space-y-2 text-sm text-gray-600">
        <li>1. 広告にしたい商品の紹介ページを入力する</li>
        <li>2. 広告に使う画像を確認する</li>
        <li>3. 自動整理された商品情報を確認する</li>
      </ol>
      <div className="flex justify-end gap-2.5">
        <button
          type="button"
          onClick={onClose}
          className="rounded-lg border border-border bg-white px-4 py-2 text-sm font-semibold text-gray-600 transition-colors hover:bg-warm-surface"
        >
          閉じる
        </button>
        <button
          type="button"
          onClick={onRegister}
          className="rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-primary-hover"
        >
          商品を登録する
        </button>
      </div>
    </div>
  </SimpleModal>
);

export default KnowledgeOnboardingGuideModal;
